import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import { businessData } from './seoConfig';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-[#FAF8F4] border-t border-[#E8DDD8]">
      <div className="max-w-6xl mx-auto px-6 md:px-20 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <div className="font-serif text-2xl text-[#0B0B0B] mb-2">
                GiGi
              </div>
              <p className="text-xs text-[#6B6970] tracking-widest uppercase">
                Hair Braiding
              </p>
            </div>
            <p className="text-sm leading-relaxed text-[#6B6970] mb-4">
              Professional hair braiding services in {businessData.city}, {businessData.state}
            </p>
            <p className="text-xs text-[#6B6970]">
              Making you feel beautiful since 2010
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#0B0B0B] font-medium mb-6 text-sm tracking-widest uppercase">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="hover:text-[#C97B63] transition-colors text-sm text-[#6B6970]"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#0B0B0B] font-medium mb-6 text-sm tracking-widest uppercase">
              Services
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970]"
                >
                  Box Braids
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970]"
                >
                  Cornrows
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970]"
                >
                  Twists
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970]"
                >
                  Goddess Braids
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970]"
                >
                  Feed-In Braids
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#0B0B0B] font-medium mb-6 text-sm tracking-widest uppercase">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`tel:${businessData.phone}`}
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970] block"
                >
                  📞 {businessData.phone}
                </a>
              </li>
              <li className="break-words">
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(
                    businessData.address
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C97B63] transition-colors text-[#6B6970]"
                >
                  📍 {businessData.address}
                  <br />
                  {businessData.city}, {businessData.state} {businessData.zip}
                </a>
              </li>
              <li>
                <div className="flex gap-3 mt-6">
                  <a
                    href={businessData.social.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="p-2 bg-[#E8DDD8] rounded-2xl hover:bg-[#C97B63] hover:text-white transition-colors text-[#0B0B0B]"
                  >
                    <FaFacebook className="w-5 h-5" />
                  </a>
                  <a
                    href={businessData.social.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="p-2 bg-[#E8DDD8] rounded-2xl hover:bg-[#C97B63] hover:text-white transition-colors text-[#0B0B0B]"
                  >
                    <FaInstagram className="w-5 h-5" />
                  </a>
                  <a
                    href={businessData.social.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                    className="p-2 bg-[#E8DDD8] rounded-2xl hover:bg-[#C97B63] hover:text-white transition-colors text-[#0B0B0B]"
                  >
                    <FaTiktok className="w-5 h-5" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#E8DDD8] pt-8">
          {/* Bottom Section */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Copyright */}
            <p className="text-sm text-[#6B6970]">
              © {currentYear} GiGi Hair Braiding. All rights reserved.
            </p>

            {/* Legal Links */}
            <div className="flex gap-6 text-sm">
              <a
                href="#"
                className="text-[#6B6970] hover:text-[#C97B63] transition-colors"
              >
                Privacy
              </a>
              <a
                href="#"
                className="text-[#6B6970] hover:text-[#C97B63] transition-colors"
              >
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
